

import { AnyAction, CombinedState, combineReducers } from '@reduxjs/toolkit'

import { actionLogReducer, type ActionLogReducer } from 'store/action-log/reducer'
import { analyticsReducer, type AnalyticsReducer } from 'store/analytics/reducer'
import { authReducer, type AuthReducer } from 'store/auth/reducer'
import { billingReducer } from 'store/billing/reducer'
import { type BillingReducer } from 'store/billing/types'
import { certificatesReducer, type CertificatesReducer } from 'store/certificates/reducer'
import { customersReducer, type ICustomersReducer } from 'store/customers/reducer'
import { ownersReducer, type IOwnersReducer } from 'store/owners/reducer'

import { shopReducer, type ShopReducer } from 'store/shop/reducer'
import { themeReducer, type ThemeReducer } from 'store/theme/reducer'
import { usersReducer, type UsersReducer } from 'store/users/reducer'

import { installationsReducer, type InstallationsState } from './installations'
import { scanSessionReducer, type ScanSessionReducer } from './scan-session/reducer'
import { tagsReducer, TagsReducer } from './tags/reducer'

export interface RootState {
  auth: AuthReducer
  certificates: CertificatesReducer
  shop: ShopReducer
  customers: ICustomersReducer
  owners: IOwnersReducer
  actionLog: ActionLogReducer
  analytics: AnalyticsReducer
  theme: ThemeReducer
  users: UsersReducer
  billing: BillingReducer
  scanSession: ScanSessionReducer
  tags: TagsReducer
  installations: InstallationsState
}

const appReducer = combineReducers({
  auth: authReducer,
  certificates: certificatesReducer,
  shop: shopReducer,
  customers: customersReducer,
  owners: ownersReducer,
  actionLog: actionLogReducer,
  analytics: analyticsReducer,
  theme: themeReducer,
  users: usersReducer,
  billing: billingReducer,
  scanSession: scanSessionReducer,
  tags: tagsReducer,
  installations: installationsReducer,
})

const rootReducer = (
  state:
    | CombinedState<{
        auth: AuthReducer
        certificates: CertificatesReducer
        shop: ShopReducer
        customers: ICustomersReducer
        owners: IOwnersReducer
        actionLog: ActionLogReducer
        analytics: AnalyticsReducer
        theme: ThemeReducer
        users: UsersReducer
        billing: BillingReducer
        scanSession: ScanSessionReducer
        tags: TagsReducer
        installations: InstallationsState
      }>
    | undefined,
  action: AnyAction
) => {
  if (action.type === 'LOGOUT_USER') {
    return appReducer(undefined, action)
  }

  return appReducer(state, action)
}

export default rootReducer
